







































import Vue from 'vue';
import EnemGradesForm, { EnemGradesFormEvent } from '@/components/forms/EnemGradesForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationEnem } from '@/store/modules/admission/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@/components/ds';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { evaluationStatusValues, EvaluationStatus } from '@/pipeline/stateMachine';

export default Vue.extend({
  components: {
    EnemGradesForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
  },
  data() {
    return {
      grades: this.$store.getters.enem?.grades || {},
      hasAcceptedToS: this.$store.getters.enem?.hasAcceptedToS,
      hasErrors: false,
      error: false,
      toastMessage: this.$t('errorMessage.enemGrades') as string,
      inepLink: 'https://enem.inep.gov.br/',
      loading: false,
    };
  },
  computed: {
    isFinishEnabled(): boolean {
      const isGradesFilled = Object.values(this.grades).every(grade => typeof grade === 'number');
      return isGradesFilled && this.hasAcceptedToS && !this.hasErrors;
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
  },
  methods: {
    async finishHandler() {
      this.loading = true;
      const enem: EvaluationEnem = { grades: this.grades, hasAcceptedToS: this.hasAcceptedToS };

      await this.$store.dispatch('UPDATE_ENEM', { enem }).catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.EVALUATION_SENT);

      await this.$store.dispatch('PULL_EVALUATION_STATUS');

      if (!evaluationStatusValues.includes(this.evaluationStatus as EvaluationStatus)) {
        // Curso/polo pode ter ficado indisponível no meio do preenchimento
        // (CHECK_ADMISSION_AVAILABILITIES zera o campus), deixando a avaliação presa
        // em 'executing'. pipeline.next() não teria efeito nenhum aqui.
        this.showToastMessage('unavailableSelectionMessage');
        return;
      }

      pipeline.next({ status: this.evaluationStatus });
      this.loading = false;
    },
    inputHandler({ grades, hasAcceptedToS, hasErrors }: EnemGradesFormEvent) {
      this.grades = grades;
      this.hasAcceptedToS = hasAcceptedToS;
      this.hasErrors = hasErrors;
    },
    showToastMessage(messageKey: string) {
      this.toastMessage = this.$t(messageKey) as string;
      this.error = true;
      setTimeout(() => {
        this.error = false;
        this.loading = false;
      }, 5000);
    },
    errorHandler(error: any) {
      this.showToastMessage('errorMessage.enemGrades');
      throw error;
    },
  },
});
